import * as api from "@/api/charts.api";
import { Chart, ChartStore } from "@lab/types/charts";

const state: ChartStore = {
	errorMessage: null,
	isFetching: false,
	lastFetched: null,
	charts: []
};

const getters = {
	get: (state): Chart[] => state.charts,
	fetching: (state) => state.isFetching,
	errorMessage: (state) => state.errorMessage
};
const actions = {
	async fetch({ commit, getters }) {
		commit("LOAD_START");
		const response = await api.fetch();

		commit("LOAD_LIST_SUCCESS", response);
	}
};
const mutations = {
	LOAD_LIST_SUCCESS(state: ChartStore, charts: Chart[]) {
		state.charts = charts;
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	LOAD_START(state: ChartStore) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	LOAD_FAILURE(state: ChartStore, message: string) {
		state.errorMessage = message;
		state.isFetching = false;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
